import { createElement } from 'react';
import { Button } from '@alifd/next';
import Submit from './submit';
import Backward from './backward';
import Save from './save';
const DEFINED_ACTIONS = {
    SUBMIT: { name: '提交', component: Submit },
    SAVE: { name: '保存', component: Save },
    BACK: { name: '退回', component: Backward },
};
const WorkflowActions = ({ operationOptions = [], ...otherProps }) => {
    return (createElement(Button.Group, { style: { display: 'flex' } }, operationOptions?.map((item) => {
        const { operationType, id } = item;
        const action = DEFINED_ACTIONS[operationType];
        if (action) {
            const Cmp = action.component;
            return createElement(Cmp, { key: id, ...item, ...otherProps });
        }
        return null;
    })));
};
export default WorkflowActions;
